import React from 'react';
import Button from 'components/DesignSystem/Button';

interface CloseButtonProps {
  id: string
  label: string
  onClick: () => void
}

export default function CloseButton({
  id,
  label,
  onClick,
}: CloseButtonProps) {
  return (
    <div className="d-flex align-items-center">
      <Button
        id={id}
        icon="close"
        type="secondary"
        onClick={onClick}
        small
        className="me-2"
      />
      {label}
    </div>
  );
}
